export default "__VITE_ASSET__URk2F3pJ__"